import Form from 'react-bootstrap/Form';
import React, {useState} from 'react';


const CheckBox = ({ attribute, label, defaultChecked = false }) => {
    // Use state to control the checked status
    const [isChecked, setIsChecked] = useState(defaultChecked);

    const handleCheck = (e) => {
        const newCheckedStatus = !isChecked;
        setIsChecked(newCheckedStatus);
    };

    return (
        <Form.Check 
            className='checkbox'
            type="checkbox"
            id={`checkbox-${attribute}-${label}`}
            label={label}
            onChange={handleCheck}
            checked={isChecked}
        />
    );
};

export default CheckBox;